import * as config from './config'
import colors from './colors'

export { config as config }
export { colors as colors }

export default {
  config,
  colors
}